import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Text,
	Link,
	ListItem,
	UnorderedList,
	ListIcon,
	List,
} from "@chakra-ui/react";
import { MdOutlineCircle } from "react-icons/md";

const FundInFocusIvycapVentures = () => {
	return (
		<>
			<Flex
				as="section"
				flexDirection="column"
				overflow="hidden"
				justify="center"
				height={{ xs: "450px", sm: "300px" }}
				minH={{ xs: "450px", sm: "300px" }}
				maxH="450px"
				pos="relative"
			>
				<Img
					pos="absolute"
					objectFit="cover"
					src="/jpg/blogBanner.jpg"
					alt="members-hero"
					height="100%"
					width="100%"
				/>
				<Box
					bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
					pos="absolute"
					height="100%"
					width="100%"
					opacity="0.7"
				/>
				<Container
					maxW="container.xl"
					position="relative"
					zIndex="1"
					flexDir="column"
					px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
				>
					<Heading
						as="h1"
						mb="20px"
						variant="reportCardTitle"
						fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
						color="white"
						lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
					>
						FUND IN FOCUS: Building for Tomorrow: Why the &apos;India
						Opportunity&apos; Excites IvyCap Ventures
					</Heading>
				</Container>
			</Flex>
			<Container
				as="section"
				maxW="container.xl"
				pb="80px"
				pt="40px"
				minH="420px"
				display={{ xs: "flex", md: "inherit" }}
				flexDirection="column"
			>
				<Box as="main" w="100%" pb="40px">
					<Text variant="blogAnswer">
						Welcome to our ‘Fund in Focus’ series where we profile our member
						funds, underscore their investment philosophy, and highlight some of
						their interesting work. Today we speak to{" "}
						<Link
							href={"https://www.linkedin.com/in/vikramgupta2/"}
							target="_blank"
							style={{
								textDecoration: "underline",
							}}
							rel="noreferrer"
						>
							Vikram Gupta
						</Link>
						, Founder and Managing Partner, IvyCap Ventures. Here he delves into
						IvyCap Ventures, a sector-agnostic fund investing in early-stage
						companies with innovative technology-based solutions. The
						&apos;India Opportunity&apos; excites IvyCap due to India&apos;s
						large, tech-savvy population and favorable regulatory reforms.
						Leveraging the global IIT alumni network, IvyCap identifies
						promising startups with scalable business models, focusing on
						sectors like healthcare, agritech, and finance.
					</Text>
				</Box>

				<Box
					backgroundImage={`url('https://static.levocdn.com/WGLBUT82/VikramGupta-n3q0flvmTTdM.jpg')`}
					float={{ xs: "right", md: "left" }}
					alignSelf={{ xs: "center", md: "flex-start" }}
					mx={{ xs: "0px", md: "0px" }}
					mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
					mb="20px"
					width="300px"
					height="300px"
					backgroundRepeat="no-repeat"
					backgroundSize="cover"
					rounded="full"
					backgroundPosition="center"
				></Box>
				<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
					<Heading
						textAlign={{ xs: "center", md: "left" }}
						fontWeight="800"
						color="blue.400"
					>
						Spokesperson: Vikram Gupta, Founder and Managing Partner, IvyCap
						Ventures
					</Heading>
				</Flex>
				<Box>
					<Box
						ml={{ xs: "auto", md: "345px", lg: "370px" }}
						mr={{ xs: "auto", md: "0px" }}
						width={{ xs: "160px", md: "80px" }}
						h="2px"
						bgColor="primary.500"
						borderRadius="5px"
						mt={{ xs: "16px", md: "10px" }}
						mb="15px"
					/>
					<Box mt="16px" mb="20px">
						<Heading variant="blogQuestion" mb="20px">
							1. Can you elaborate on IvyCap Ventures' investment thesis and
							focus areas? How do you identify promising investment
							opportunities within these sectors?
						</Heading>
						<Text variant="blogAnswer">
							We are a sector-agnostic fund driven by a strong belief in the
							power of individuals to ignite innovation and disruption. Our
							focus is on investing in early-stage companies with differentiated
							business models and robust unit economics. We target startups in
							the early to growth stages (Seed, Pre-Series A, Series A, and
							Series B) that are developing innovative technology-based
							products, services, and business solutions capable of scaling and
							competing in a competitive market.
							<br />
							<br />
							Leveraging the global IIT alumni ecosystem, our investment
							philosophy centers on identifying and nurturing innovative ideas
							and startups positioned to excel in an era of exponential growth.
							We prioritize the evaluation of founding teams as our primary
							criterion for investment, closely followed by a comprehensive
							assessment of a business's growth potential, scalability, and unit
							economics. Our goal is to invest in capital-efficient enterprises
							capable of scaling with minimal capital infusion. Moreover, we
							place significant emphasis on Sustainable Development Goals (SDGs)
							and corporate governance in our investment approach.
						</Text>
					</Box>
					{/* Question 2 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pb="20px" pt="12px">
							2. What excites you about the 'India Opportunity'?
						</Heading>
						<Text variant="blogAnswer" mt="16px" mb="8px">
							India's demographics play a pivotal role in this opportunity. With
							a population of over 1.44 billion people and a growing middle
							class, the country boasts heightened consumption levels. Moreover,
							India has experienced extensive digital penetration, with a
							significant portion of the population accessing the internet
							through smartphones. This widespread adoption of technology
							presents fertile ground for the continued growth of consumer tech
							companies, poised to cater to the evolving needs and preferences
							of Indian consumers.
							<br />
							<br />
							Furthermore, the growing significance of technology solutions is
							reshaping the startup ecosystem in India. These technologies are
							driving innovation across various sectors, from healthcare to
							agritech to finance, and offering immense opportunities for
							startups to disrupt traditional industries. As India continues to
							embrace technological advancements, it solidifies its position as
							a hub for cutting-edge technology and disruptive innovation.
							<br />
							<br />
							India's regulatory landscape has undergone significant reforms
							aimed at streamlining processes and enhancing transparency. These
							reforms have contributed to a more investor-friendly environment,
							where regulatory uncertainties are minimized, and compliance
							procedures are more straightforward. The stability of the
							political environment further reinforces investor confidence.
							<br />
							<br />
							Thus, collectively, these factors contribute to the allure of the
							'India Opportunity,' making it an exciting and promising
							destination for investment with vast potential for growth and
							innovation.
						</Text>
					</Box>

					{/* Question 3 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pt="28px">
							3. Could you highlight a few notable success stories from IvyCap's
							portfolio, showcasing how the firm's investment and support have
							helped start-ups thrive and achieve significant milestones?
						</Heading>
						<Text variant="blogAnswer" mt="16px" mb="8px">
							Yes, there are several success stories:
						</Text>
						<Text variant="blogAnswer" py="16px">
							<Text as="span" variant="blogQuestion" fontWeight="700">
								Purplle:
							</Text>{" "}
							We invested in Purplle.com from our Fund 1 and Fund 2. When we
							first invested in Purplle in 2015, we were confident that
							technology would disrupt and redefine the beauty industry in
							India. With an initial investment of $2M (INR 15 crore) from our
							Fund 1 growing manifold to USD 45M, our partnership has been
							rewarding. Achieving a 22X return, our belief in the brand and the
							vision of its founders, 'Beauty for All', enabled us to generate
							1.35x of our entire Fund 1 in Purplle. This is the first Dragon
							from our portfolio.
						</Text>
						<Text variant="blogAnswer" py="16px">
							<Text as="span" variant="blogQuestion" fontWeight="700">
								Clovia:
							</Text>{" "}
							We invested Rs 15 crore from Fund 1 in 2015 and just over Rs 30
							crore from Fund 2 in 2019. We owned more than one-third of the
							company between Fund 1 and 2 at the time of the sale. At the time
							of the exit, Reliance Retail Ventures Limited (RRVL) acquired an
							89 percent equity stake in Purple Panda Fashions Private Limited,
							which owns and operates the intimate wear brand Clovia.
						</Text>
						<Text variant="blogAnswer" py="16px">
							<Text as="span" variant="blogQuestion" fontWeight="700">
								Pharmarack:
							</Text>{" "}
							In 2021, we announced the sale of our stake in the
							business-to-business (B2B) healthtech platform Pharmarack at an
							internal rate of return (IRR) of 104%. We sold our stake in the
							acquisition deal for Pharmarack for INR 42 Cr ($5.5 Mn) after
							investing INR 21 Cr ($2.8 Mn). Pharmarack's acquisition by a
							consortium of pharma giants including Sun Pharma and Cadilla
							Pharma is indeed a success story.
						</Text>
						<Text variant="blogAnswer" py="16px">
							<Text as="span" variant="blogQuestion" fontWeight="700">
								BlueStone:
							</Text>{" "}
							Another portfolio company, BlueStone, will soon be announcing its
							IPO. The success of BlueStone in the jewelry industry debunked all
							apprehensions about the online jewelry segment. The company has
							150 physical stores, making them one of the top jewelry sellers in
							the country.
						</Text>
						<Text variant="blogAnswer" mt="16px" mb="8px">
							Our other notable exits include Sokrati's acquisition by Dentsu
							International, Aujas’s acquisition by NSEIT, and others.
						</Text>
					</Box>

					{/* Question 4 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pt="16px">
							4. IvyCap emphasizes investing in passionate founding teams with
							credible professional experience. Could you share some criteria or
							characteristics that IvyCap looks for in founding teams during the
							investment evaluation process?
						</Heading>
						<Text variant="blogAnswer" py="16px">
							We have always placed significant emphasis on investing in
							passionate founders who are excited about the disruption or
							innovation they bring. During our investment evaluation process,
							we meticulously assess various criteria and characteristics to
							determine the suitability of founding teams:
						</Text>
						<UnorderedList>
							<ListItem>
								<Text variant="blogAnswer" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Mindset of the founder:
									</Text>{" "}
									We scrutinize the EQ and IQ levels of the founders, valuing
									those with a growth-oriented mindset. Resilience,
									adaptability, and forward-thinking are paramount qualities we
									seek, as they enable founders to navigate challenges and seize
									opportunities in a dynamic market environment.
								</Text>
							</ListItem>
							<ListItem>
								<Text variant="blogAnswer" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Passion for creating something innovative:
									</Text>{" "}
									Founders driven by passion are more likely to persevere and
									succeed in their endeavours. We prioritize entrepreneurs who
									exhibit deep enthusiasm for their vision and demonstrate
									unwavering commitment to achieving their business objectives.
									This led us to invest in diverse industries like Biryani by
									Kilo, Purplle, BlueStone, Eggoz, Miko, as well as companies
									like YelloSkye, Celcius, Agraga, ZestIot, GradRight, etc.
								</Text>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Skillset of the team:
									</Text>{" "}
									We have always believed in investing in entrepreneurs and
									their team. A diverse skill set within the team is crucial for
									addressing the multifaceted demands of business development
									and scalability. We evaluate the technical, managerial, and
									leadership capabilities of the founders and their team
									members, ensuring they possess the necessary expertise to
									execute their business strategy effectively.
								</Text>
							</ListItem>
							<ListItem>
								<Text variant="blogAnswer" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Business Model and Value Perception:
									</Text>{" "}
									We scrutinize the business model for its capital efficiency
									and assess the founders' perception of value in us.
									Additionally, we consider the terms and pricing of the deal,
									ensuring alignment of interests between IvyCap Ventures and
									the founding team. By prioritizing these qualities in founding
									teams, we aim to identify entrepreneurs who possess not only a
									compelling business idea but also the passion, skills, and
									collaborative spirit necessary for successful execution.
								</Text>
							</ListItem>
						</UnorderedList>
					</Box>
					{/* Question 5 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pt="16px">
							5. The firm leverages global alumni networks to create a
							competitive advantage. How does IvyCap harness these networks to
							support portfolio companies and drive growth?
						</Heading>
						<Text variant="blogAnswer" py="16px">
							We leverage global alumni networks to gain a competitive advantage
							and bolster the growth of portfolio companies. Comprising
							distinguished leaders from prestigious Indian educational
							institutions such as the IITs and IIMs, the alumni network offers
							a unique platform with unparalleled access to high-quality
							resources. These networks help harnessing to source deals
							effectively. The extensive reach of the alumni network enables the
							firm to tap into a wide pool of potential investment
							opportunities, providing access to promising startups and
							innovative ventures across various sectors. Moreover, the alumni
							ecosystem serves as a valuable resource for finding the right
							talent and mentors for portfolio companies. They can offer
							guidance, mentorship, and strategic insights.
						</Text>
					</Box>
					{/* Question 6 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pt="16px">
							6. Active mentoring is a key aspect of IvyCap's support ecosystem
							for startups. Could you elaborate on the type of mentorship
							provided to portfolio companies and how it contributes to their
							success?
						</Heading>
						<Text variant="blogAnswer" py="16px">
							The startup journey can be quite arduous and lonely for founders.
							Many times, founders look for a confidant to hear them out,
							besides guidance on solving specific business problems. We, along
							with our mentors, are sensitive to the softer aspects of a
							founder-mentor relationship, and it has played a significant role
							in the success of our mentor model. Our mentorship model is
							distinctive and well-organized, offering comprehensive support for
							execution, scale-up, and exit strategies to our portfolio
							companies. Comprising both corporate executives and accomplished
							founders with firsthand entrepreneurial experience, our mentor
							pool equips each portfolio company with invaluable guidance. These
							mentors provide dynamic coaching across various areas such as
							strategy development, capacity building, recruitment, and
							go-to-market strategies, ensuring that our portfolio companies
							receive tailored support for their specific needs throughout their
							journey.
							<br />
							<br />
							Examples of our successful mentorship include partnering Clovia
							with industry luminaries like Sharon Jester Turney and Ravi
							Dhariwal for brand building and omni-channel strategy. Also,
							mentors adept in the beauty industry helped Purplle execute a
							brand strategy. These examples show how our mentorship model
							drives tangible results and contributes to the growth of our
							portfolio companies.
						</Text>
					</Box>
					{/* Question 7 */}
					<Box my="16px">
						<Heading variant="blogQuestion" pt="16px">
							7. Sustainability and responsible investing are integral to
							IvyCap's philosophy. How does the firm incorporate Sustainable
							Development Goals (SDGs) into its investment decisions? Can you
							provide examples of portfolio companies that have successfully
							aligned their business models with SDGs?
						</Heading>
						<Text variant="blogAnswer" py="16px">
							In the fast-evolving world of investments, sustainability is no
							longer a mere buzzword but a cornerstone for success. Every
							decision made today has the potential to shape the future, and at
							IvyCap Ventures, sustainability is woven into the fabric of our
							investment philosophy. For over four years, we have made it a
							fundamental part of our approach. Our dedicated Sustainable
							Development Goals (SDG) team meticulously evaluates potential
							investments, scrutinizing environmental and social impacts from
							inception to exit. We go beyond lip service, actively exploring
							ways to amplify the positive impact of our portfolio companies.
							Each of our investments aligns with SDGs, with our companies
							actively tracking their targets. The tangible positive outcomes
							across our portfolio stand testament to the success of this
							commitment. Decarbonization and social equity take center stage in
							our strategy as we assess each company's potential for SDG impact
							and help build robust governance structures. Our emphasis is on
							integrating SDG goals into every aspect of a company's operations
							before taking a philanthropic approach to sustainability. From
							waste and water management to workforce health, safety, and
							product distribution, we set metrics, policies, and KPIs,
							conducting annual impact assessments.
							<br />
							<br />
							Examples of SDG initiatives for our portfolio companies include:
						</Text>
						<UnorderedList>
							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Biryani By Kilo:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											The expansion of the business unit has led to hiring from
											Tier-2 areas, facilitating significant employment
											generation and the establishment of a reputable brand name
											for the company
										</Text>
									</ListItem>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											The organic packaging is sourced from local artisans,
											bolstering the community's income and providing
											opportunities for skill expansion on a broader level.
										</Text>
									</ListItem>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											1,33,154 free food packages served.
										</Text>
									</ListItem>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Packaging is organic and sourced from local artisans,
											supporting the community with better income and prospects
											of expanding their skills on a larger scale.
										</Text>
									</ListItem>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											50 Lakh customers served in earthen clay pots sourced by
											local kumhaars.
										</Text>
									</ListItem>
								</List>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Celcius Logistics:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Vaahan Vikas Yojana- Bridging the gap by incentivizing the
											adoption of Reefer vehicles among transporters, providing
											various benefits to the Regional Transporters that act as
											strong incentives for them to participate, including
											monthly assured income, consistent year-round business,
											funding, growth opportunities, and access to the entire
											Celcius Tech platform.
										</Text>
									</ListItem>
								</List>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Expertrons:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Over 500,000 users, including 5,000 paid, have boosted
											their careers with better salaries and jobs. Mentorship
											and guidance programs have empowered economically
											disadvantaged individuals to escape poverty.
										</Text>
									</ListItem>
								</List>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Clover Ventures (Deep Rooted):
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Engage with over 1,000 farmers to promote Sustainable
											Farming Practices, including controlled environment
											farming for yearlong consistent high quality,
											pesticide-free practice using natural and biological
											alternatives, intercropping to divert pests away from the
											main crop, drip irrigation for timely and adequate usage
											of water saving water by 60 percent, precision farming
											using technology for optimal resource utilization,
											mulching to retain soil moisture, prevent weeds and
											herbicide usage, crop rotation for maintaining soil
											health, contour farming, and hydroponics.
										</Text>
									</ListItem>

									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Impacted more than 1000 farmers, cultivating over 1500
											acres of land, for over 300 varieties of fruits and
											vegetables delivered within 16-20 hours from farms
											{` < 150`} kms away.
										</Text>
									</ListItem>
								</List>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Eggoz:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Initiative taken: The company collaborates with the Bill &
											Melinda Gates Foundation and ICICI Foundation to introduce
											a small-scale model for farmers, requiring an investment
											budget of only 3-4 lakhs. 1/4th the emissions of a
											conventional model.
										</Text>
									</ListItem>
								</List>
							</ListItem>
							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									FtCash:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											Initiative taken: Enable micro-merchants, small
											businesses, retail chains, and home-based entrepreneurs to
											utilize the potential of mobile payments. FTcash has an
											incredibly positive impact on 1000+ small merchants,
											businesses, retail outlets, and individuals to be
											inclusive in utilizing the other means of financial
											transactions which are done through other than cash. It is
											the objective of the company to bring everyone under an
											umbrella.
										</Text>
									</ListItem>
								</List>
							</ListItem>

							<ListItem>
								<Text variant="blogAnswer" py="16px" fontWeight="700">
									Miko:
								</Text>
								<List>
									<ListItem display="flex" position="relative" py="8px">
										<ListIcon as={MdOutlineCircle} fontSize="10px" mt="10px" />
										<Text variant="blogAnswer" py="0px" as="span">
											The company recycles 100% of the e-wastes generated, which
											is roughly 1262 tonnes.
										</Text>
									</ListItem>
								</List>
							</ListItem>
						</UnorderedList>
					</Box>
				</Box>

				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						8. IvyCap is committed to upholding high-quality governance
						structures. How does the firm ensure strong governance within its
						portfolio companies, and what role does it play in mitigating risks
						and driving long-term value creation?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						In an era of heightened corporate governance scrutiny, IvyCap
						Ventures has always prioritized strong governance as a cornerstone
						of our investment strategy. We recognize that the dynamic startup
						landscape demands more than just financial acumen—it requires
						unwavering commitment to ethical operations. Hence, corporate
						governance is not a mere checkbox; it is a guiding set of principles
						that inform every decision. We take proactive steps to ensure our
						portfolio companies operate responsibly, nurturing them to surpass
						profitability expectations through transparent and responsible
						governance practices.
					</Text>
				</Box>

				<Heading
					variant="blogQuestion"
					lineHeight="30px"
					pt="16px"
					fontStyle="italic"
					p="12px 12px 0px"
				>
					The content in this section is curated by Team IVCA. For any feedback,
					connect with&nbsp;
					<Link
						href="mailto:paromita.sinha@ivca.in"
						target="_blank"
						style={{ color: "blue", textDecoration: "underline" }}
					>
						paromita.sinha@ivca.in
					</Link>
				</Heading>
			</Container>
		</>
	);
};

export default FundInFocusIvycapVentures;
